<ng-container [formGroup]="formGroup">
  <dsd-radio-group required="true" name="type-{{ name }}" class="dsd-mb-sm">
    <span slot="legend">{{ 'caad.modifier-coordonnees.telephones.typeLegende' | translate }}</span>
    <span slot="error">{{ 'caad.modifier-coordonnees.telephones.erreur.typeVide' | translate }}</span>
    <dsd-radio
      value="CELLULAIRE"
      name="type-cell-{{ name }}"
      (dsdRadioChange)="typeTelephone(telephoneTypeEnum.CELLULAIRE)"
      [checked]="formGroup.get('typeTelephone')?.value === telephoneTypeEnum.CELLULAIRE"
      >{{ 'caad.modifier-coordonnees.telephones.typeCellulaire' | translate }}</dsd-radio
    >
    <dsd-radio
      value="TELEPHONE"
      name="type-fixe-{{ name }}"
      (dsdRadioChange)="typeTelephone(telephoneTypeEnum.TELEPHONE)"
      [checked]="formGroup.get('typeTelephone')?.value === telephoneTypeEnum.TELEPHONE"
      >{{ 'caad.modifier-coordonnees.telephones.typeFixe' | translate }}</dsd-radio
    >
  </dsd-radio-group>

  <div class="dsd-d-flex">
    <dsd-input
      #telephone
      [identifier]="'telephone-' + name"
      formControlName="telephone"
      [name]="'telephone-' + name"
      custom-type="tel"
      required="true"
      class="dsd-mr-sm dsd-mb-0">
      <span slot="label">{{ 'caad.modifier-coordonnees.telephones.numero' | translate }}</span>
      <span slot="hint"></span>
      <span slot="error">
        <span data-error-key="mask">{{
          'caad.modifier-coordonnees.telephones.erreur.telephoneInvalide' | translate
        }}</span>
        <span data-error-key="required">{{
          'caad.modifier-coordonnees.telephones.erreur.telephoneVide' | translate
        }}</span>
      </span>
    </dsd-input>
    <dsd-input
      [identifier]="'poste-' + name"
      class="dsd-mb-0"
      formControlName="poste"
      [name]="'poste-' + name"
      [maxlength]="variantTravail ? 10 : 4"
      type="tel"
      *ngIf="formGroup?.get('typeTelephone')?.value === telephoneTypeEnum.TELEPHONE">
      <span slot="label"
        ><span aria-hidden="true">{{ 'caad.modifier-coordonnees.telephones.poste' | translate }}</span
        ><span class="dsd-sr-only">{{ 'caad.modifier-coordonnees.telephones.horsEcran.poste' | translate }}</span></span
      >
      <span slot="error">
        <span data-error-key="maxlength">{{
          'caad.modifier-coordonnees.telephones.erreur.poste' + (variantTravail ? 'Travail' : '') + 'Invalide'
            | translate
        }}</span>
      </span>
    </dsd-input>
  </div>
</ng-container>
